import { PayModeLevel1 } from '@fitness-force/enum';
import type { PaymentSignUp } from '@fitness-force/models';

/** API expects string enum names (see AmendmentPaymentDtos / Field-Level API Reference). */
export function mapAmendmentOfflinePaymentForExecute(
  paymentObj: PaymentSignUp,
  amountInMinorCurrency: number,
): Omit<PaymentSignUp, 'paymode_level1'> & { paymode_level1: string } {
  const level1 = paymentObj.paymode_level1;
  const paymodeLevel1 =
    typeof level1 === 'number' ? (PayModeLevel1[level1] as string) : String(level1);

  return {
    ...paymentObj,
    paymode_level1: paymodeLevel1,
    amount_in_minor_currency: amountInMinorCurrency,
  };
}

export function resolveAmendmentOfflineCollectedMinor(
  paymentObj: PaymentSignUp | null | undefined,
): number {
  if (paymentObj?.amount_in_minor_currency && paymentObj.amount_in_minor_currency > 0) {
    return paymentObj.amount_in_minor_currency;
  }
  return paymentObj?.rounded_amount_in_minor_currency ?? 0;
}
